module.exports = __webpack_public_path__ + "static/media/5.23_preview.42a5cb38.png";